import { Empty } from '../Common/Empty'
import type { PostType, DraftPreview } from '../types'
import { StartPagePost } from './components/Post'
import { PostPreviewCard } from '../Common/styles'

export const StartPagesPreview = ({
  draft,
}: {
  draft: DraftPreview
}): React.JSX.Element => {
  if (draft.isEmpty) return <Empty />

  const draftStartPage: PostType = {
    content: {
      ...draft,
      text: draft.text,
    },
  }

  return (
    <PostPreviewCard data-testid="startpages-preview">
      <StartPagePost content={draftStartPage.content} />
    </PostPreviewCard>
  )
}
